function findSurveyContent(block, cb) {
  for (const content of block?.children || []) {
    if (cb(content)) {
      return content;
    }
    if (content.block) {
      const res = findSurveyContent(content.block, cb);

      if (res) {
        return res;
      }
    }
  }

  return null;
}

module.exports = findSurveyContent;
